export const convertToNumber = (input: string | number) => {
    const str = input.toString().trim();
    const normalizesString = str?.replace(',', '.')
    let number = parseFloat(normalizesString);
    const formattedNum = number.toFixed(2);
    number = Number(formattedNum + '0');
    return number;
}